// src/app/views/nft/Nft.tsx

'use client';
/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import styles from './Nft.module.scss';
import TerminalHeader from '../terminal-header/TerminalHeader';

const NFT: React.FC = () => {
  return (
    <div className={styles.nft}>
      {/* Terminal Header */}
      <TerminalHeader />

      {/* Title (reserved) */}
      <h2 className={styles['nft__title']}></h2>

      {/* Intro Paragraph */}
      <p className={styles['nft__paragraph']}>
        {`> The ChadOS Floppy Disk. Probably something.`}
      </p>

      {/* Embed video */}
      <div className={styles['nft__video']}>
        <video
          src='/video/nft.mp4'
          title='ChadOS Floppy Disk'
          controls
          playsInline
        />
      </div>

      {/* Additional Details */}
      <p className={styles['nft__paragraph']}>{`Mint coming soon`}</p>
    </div>
  );
};

export default NFT;
